'use strict'

import './wp-content/themes/skytrax-awards/assets/js/index.js'
import './wp-content/themes/skytrax-awards/assets/scss/index.scss'